import React from 'react';
import { useNavigate } from 'react-router-dom';

const ClimateAction = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white">
      <div className="bg-white border-b border-grey-200">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <button
            onClick={() => navigate(-1)}
            className="mb-4 text-green-600 hover:text-green-700 flex items-center gap-2 font-medium"
          >
            ← Back
          </button>
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <svg className="w-7 h-7 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
              </svg>
            </div>
            <div>
              <h1 className="text-3xl font-bold text-grey-900">Climate Action</h1>
              <p className="text-green-600 font-medium">Planting Trees, Growing Communities</p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden mb-8">
          <div className="bg-gradient-to-r from-green-600 to-emerald-500 p-8 text-white">
            <h2 className="text-2xl font-bold mb-2">One Event, One Tree</h2>
            <p className="text-green-100 text-lg">
              Every vendor registration can contribute to local reforestation efforts
            </p>
          </div>
          
          <div className="p-8">
            <div className="grid md:grid-cols-3 gap-6 mb-8">
              <div className="text-center p-6 bg-green-50 rounded-xl">
                <div className="text-4xl font-bold text-green-600 mb-2">$2</div>
                <p className="text-grey-600">Per Tree Donation</p>
              </div>
              <div className="text-center p-6 bg-green-50 rounded-xl">
                <div className="text-4xl font-bold text-green-600 mb-2">100%</div>
                <p className="text-grey-600">Goes to Planting</p>
              </div>
              <div className="text-center p-6 bg-green-50 rounded-xl">
                <div className="text-4xl font-bold text-green-600 mb-2">Local</div>
                <p className="text-grey-600">Community Impact</p>
              </div>
            </div>

            <h3 className="text-xl font-semibold text-grey-900 mb-4">How It Works</h3>
            
            <div className="space-y-6">
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                  <span className="text-green-600 font-bold">1</span>
                </div>
                <div>
                  <h4 className="font-semibold text-grey-900">Event Organizers Enable Tree Planting</h4>
                  <p className="text-grey-600">When creating an event, organizers can choose to enable or require a $2 tree planting donation from vendors.</p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                  <span className="text-green-600 font-bold">2</span>
                </div>
                <div>
                  <h4 className="font-semibold text-grey-900">Vendors Contribute During Registration</h4>
                  <p className="text-grey-600">When registering for an event, vendors can opt-in to donate $2 for tree planting. Some events may make this a requirement.</p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                  <span className="text-green-600 font-bold">3</span>
                </div>
                <div>
                  <h4 className="font-semibold text-grey-900">Trees Are Planted Locally</h4>
                  <p className="text-grey-600">100% of donations go directly to our partner organizations who plant native trees in communities where events take place.</p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                  <span className="text-green-600 font-bold">4</span>
                </div>
                <div>
                  <h4 className="font-semibold text-grey-900">No Platform Fees on Donations</h4>
                  <p className="text-grey-600">Pebble does not take any platform fees from tree planting donations. Every dollar goes toward environmental impact.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
          <h3 className="text-xl font-semibold text-grey-900 mb-4">Why Trees Matter</h3>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="flex gap-3">
              <div className="flex-shrink-0 text-green-500">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <div>
                <h4 className="font-medium text-grey-900">Carbon Absorption</h4>
                <p className="text-grey-600 text-sm">A single tree can absorb up to 48 pounds of CO2 per year</p>
              </div>
            </div>

            <div className="flex gap-3">
              <div className="flex-shrink-0 text-green-500">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <div>
                <h4 className="font-medium text-grey-900">Air Quality</h4>
                <p className="text-grey-600 text-sm">Trees filter pollutants and produce clean oxygen</p>
              </div>
            </div>

            <div className="flex gap-3">
              <div className="flex-shrink-0 text-green-500">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <div>
                <h4 className="font-medium text-grey-900">Wildlife Habitat</h4>
                <p className="text-grey-600 text-sm">Trees provide homes for birds, insects, and small mammals</p>
              </div>
            </div>

            <div className="flex gap-3">
              <div className="flex-shrink-0 text-green-500">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <div>
                <h4 className="font-medium text-grey-900">Community Beautification</h4>
                <p className="text-grey-600 text-sm">Green spaces improve mental health and property values</p>
              </div>
            </div>

            <div className="flex gap-3">
              <div className="flex-shrink-0 text-green-500">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <div>
                <h4 className="font-medium text-grey-900">Urban Cooling</h4>
                <p className="text-grey-600 text-sm">Trees reduce urban heat islands and lower energy costs</p>
              </div>
            </div>

            <div className="flex gap-3">
              <div className="flex-shrink-0 text-green-500">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <div>
                <h4 className="font-medium text-grey-900">Stormwater Management</h4>
                <p className="text-grey-600 text-sm">Trees reduce flooding and filter rainwater naturally</p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-green-600 to-emerald-500 rounded-2xl p-8 text-white text-center">
          <h3 className="text-2xl font-bold mb-3">Join the Movement</h3>
          <p className="text-green-100 mb-6 max-w-2xl mx-auto">
            Whether you're an event organizer enabling tree donations or a vendor choosing to contribute, 
            every tree makes a difference. Together, we're building a greener future one event at a time.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <button 
              onClick={() => navigate('/create-account')}
              className="bg-white text-green-600 px-6 py-3 rounded-lg font-semibold hover:bg-green-50 transition-colors"
            >
              Get Started
            </button>
            <button 
              onClick={() => navigate('/browse-events')}
              className="bg-green-700 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-800 transition-colors border border-green-500"
            >
              Browse Events
            </button>
          </div>
        </div>

        <div className="mt-8 text-center text-grey-500 text-sm">
          <p>
            Pebble partners with verified reforestation organizations to ensure every donation results in real tree planting.
            For questions about our climate action program, contact us at{' '}
            <a href="mailto:climate@pebbletheapp.com" className="text-green-600 hover:underline">
              climate@pebbletheapp.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ClimateAction;
